export default __webpack_public_path__ + "static/media/expl_012_EN.0c7e37fd.png";